import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import DialogContent from "@material-ui/core/DialogContent";
import { Box, Grid, Switch, Typography } from "@material-ui/core";
import Button from "@material-ui/core/Button";
import DialogActions from "@material-ui/core/DialogActions";
import TextField from "@material-ui/core/TextField";
import PropTypes from "prop-types";
import SbuSelect from "../../_shared/SbuSelect";
import { utilFunctions } from "../../../_helpers";
import FormControlWrapper from "../../_shared/FormControlWrapper";

const PlantAdd = (props) => {
    const INITIAL_STATE = {
        factoryId: { value: null },
        sbu: { value: '', validator: 'text', isRequired: true, error: null },
        plantCode: { value: '', validator: 'text', isRequired: true, error: null },
        plantName: { value: '', validator: 'text', isRequired: true, error: null },
        factoryCode: { value: '', validator: 'text', isRequired: true, error: null },
        factoryName: { value: '', validator: 'text', isRequired: true, error: null },
        isActive: { value: true }
    }
    const [plantData, setPlantData] = useState(INITIAL_STATE);

    React.useEffect(() => {
        if (!!props.plant) {
            setPlantData({
                ...plantData,
                factoryId: { ...plantData.factoryId, value: props.plant.factoryId },
                sbu: { ...plantData.sbu, value: props.plant.sbuId },
                plantCode: { ...plantData.plantCode, value: props.plant.plantCode },
                plantName: { ...plantData.plantName, value: props.plant.plantName },
                factoryCode: { ...plantData.factoryCode, value: props.plant.factoryCode },
                factoryName: { ...plantData.factoryName, value: props.plant.factoryName },
                isActive: { ...plantData.isActive, value: props.plant.isActive },
            })
        }
        if (props.reset > 0) {
            handleClear();
        }
    }, [props.plant, props.reset])

    const handleChange = (property, value) => {
        setPlantData({
            ...plantData,
            [property]: {
                ...plantData[property],
                value: value,
                error: null
            }
        })
    }

    const onSbuChange = (value) => {
        setPlantData({
            ...plantData,
            sbu: {
                ...plantData.sbu,
                value: value
            }
        })
    }

    const handleClear = () => {
        setPlantData(INITIAL_STATE)
    }

    const validateForm = async () => {
        const [validatedData, isValid]: any = await utilFunctions.validateFormData(plantData)
        setPlantData({ ...validatedData })
        if (isValid) {
            props.addPlant(validatedData);
        }
    }

    return (
        <React.Fragment>
            <DialogContent>
                <Typography className="uppercase fontSizePrimary">Please fill the detail below to add a new factory to the platform.</Typography>

                <Grid container spacing={2} className="mtM">
                    <Grid item xs={12} sm={12} md={6} lg={6}>
                        <FormControlWrapper label="SBU" variant="block" isRequired={plantData.sbu.isRequired}>
                            <SbuSelect
                                sbus={props.sbus}
                                onSbuChange={onSbuChange}
                                selectedValue={plantData.sbu.value}
                            />
                        </FormControlWrapper>
                    </Grid>
                    <Grid item xs={12} sm={12} md={6} lg={6}>
                        <FormControlWrapper label="Plant Code" variant="block" isRequired={plantData.plantCode.isRequired}>
                            <TextField
                                id="outlined-textarea"
                                onChange={(event) => handleChange('plantCode', event.target.value)}
                                value={plantData.plantCode.value}
                                error={!!plantData.plantCode.error}
                                size="small"
                                variant="outlined"
                            />
                        </FormControlWrapper>
                    </Grid>

                    <Grid item xs={12} sm={12} md={6} lg={6}>
                        <FormControlWrapper label="Plant Name" variant="block" isRequired={plantData.plantName.isRequired}>
                            <TextField
                                id="outlined-textarea"
                                onChange={(event) => handleChange('plantName', event.target.value)}
                                value={plantData.plantName.value}
                                error={!!plantData.plantName.error}
                                size="small"
                                variant="outlined"
                            />
                        </FormControlWrapper>
                    </Grid>

                    <Grid item xs={12} sm={12} md={6} lg={6}>
                        <FormControlWrapper label="Factory Code" variant="block" isRequired={plantData.factoryCode.isRequired}>
                            <TextField
                                id="outlined-textarea"
                                onChange={(event) => handleChange('factoryCode', event.target.value)}
                                value={plantData.factoryCode.value}
                                error={!!plantData.factoryCode.error}
                                size="small"
                                variant="outlined"
                            />
                        </FormControlWrapper>
                    </Grid>

                    <Grid item xs={12} sm={12} md={6} lg={6}>
                        <FormControlWrapper label="Factory Name" variant="block" isRequired={plantData.factoryName.isRequired}>
                            <TextField
                                id="outlined-textarea"
                                onChange={(event) => handleChange('factoryName', event.target.value)}
                                value={plantData.factoryName.value}
                                error={!!plantData.factoryName.error}
                                size="small"
                                variant="outlined"
                            />
                        </FormControlWrapper>
                    </Grid>

                    <Grid item xs={12} sm={12} md={6} lg={6}>
                        <FormControlWrapper label="Is Active" variant="block">
                            <Switch
                                checked={plantData.isActive.value}
                                onChange={(event) => handleChange('isActive', event.target.checked)}
                                name="checkedA"
                                color="primary"
                                inputProps={{ 'aria-label': 'secondary checkbox' }}
                            />
                        </FormControlWrapper>
                    </Grid>
                </Grid>
            </DialogContent>
            <DialogActions>
                <Button variant="contained" onClick={handleClear}>
                    Clear
                </Button>
                <Button variant="contained" color="secondary" onClick={validateForm}>
                    Save
                </Button>
            </DialogActions>
        </React.Fragment>
    )
}

PlantAdd.propTypes = {
    plant: PropTypes.any,
    addPlant: PropTypes.func,
    onClose: PropTypes.func,
    reset: PropTypes.number,
    sbus: PropTypes.array
}

PlantAdd.defaultProps = {
    reset: 0,
    sbus: []
}

export default PlantAdd;
